import { CACHE_TAG_ACCOUNT_STATEMENT_LIST } from 'api/cacheTagTypes'
import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getStatementListByAccount: builder.query({
      query: ({ accountId }) => ({
        url: `/api/v1/core/statements/${accountId}/statements`,
      }),
      providesTags: [CACHE_TAG_ACCOUNT_STATEMENT_LIST],
    }),
    generateStatement: builder.mutation({
      query: ({ accountId, term, startDate, endDate }) => ({
        url: `/api/v1/core/statements/generate`,
        method: 'POST',
        body: {
          accountId,
          term,
          startDate,
          endDate,
        },
      }),
      invalidatesTags: [CACHE_TAG_ACCOUNT_STATEMENT_LIST],
    }),
    getEarliestStatementDate: builder.query({
      query: ({ accountId }) => ({
        url: `/api/v1/core/statements/${accountId}/statementperiod`,
        method: 'GET',
      }),
    }),
    sendStatement: builder.mutation({
      query: ({ statementIds }) => ({
        url: `/api/v1/core/statements/send`,
        method: 'POST',
        body: {
          statementIds,
        },
      }),
      invalidatesTags: [CACHE_TAG_ACCOUNT_STATEMENT_LIST],
    }),
  }),
})

export const { useLazyGetStatementListByAccountQuery, useGenerateStatementMutation, useSendStatementMutation, useLazyGetEarliestStatementDateQuery } = extendedApi
